/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { adminControllerBlockOrUnblock } from '../fn/admin/admin-controller-block-or-unblock';
import { AdminControllerBlockOrUnblock$Params } from '../fn/admin/admin-controller-block-or-unblock';
import { adminControllerCreate } from '../fn/admin/admin-controller-create';
import { AdminControllerCreate$Params } from '../fn/admin/admin-controller-create';
import { adminControllerDelete } from '../fn/admin/admin-controller-delete';
import { AdminControllerDelete$Params } from '../fn/admin/admin-controller-delete';
import { adminControllerFindAll } from '../fn/admin/admin-controller-find-all';
import { AdminControllerFindAll$Params } from '../fn/admin/admin-controller-find-all';
import { adminControllerFindById } from '../fn/admin/admin-controller-find-by-id';
import { AdminControllerFindById$Params } from '../fn/admin/admin-controller-find-by-id';
import { adminControllerGet } from '../fn/admin/admin-controller-get';
import { AdminControllerGet$Params } from '../fn/admin/admin-controller-get';
import { adminControllerLogin } from '../fn/admin/admin-controller-login';
import { AdminControllerLogin$Params } from '../fn/admin/admin-controller-login';
import { adminControllerResetPassword } from '../fn/admin/admin-controller-reset-password';
import { AdminControllerResetPassword$Params } from '../fn/admin/admin-controller-reset-password';
import { AdminDto } from '../models/admin-dto';

@Injectable({ providedIn: 'root' })
export class AdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminControllerGet()` */
  static readonly AdminControllerGetPath = '/api/v1/admin';

  /**
   * 관리자 조회.
   *
   * 로그인한 관리자를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerGet$Response(params?: AdminControllerGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    return adminControllerGet(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 조회.
   *
   * 로그인한 관리자를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerGet(params?: AdminControllerGet$Params, context?: HttpContext): Observable<AdminDto> {
    return this.adminControllerGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminControllerCreate()` */
  static readonly AdminControllerCreatePath = '/api/v1/admin';

  /**
   * 관리자 등록.
   *
   * 관리자를 등록합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerCreate$Response(params: AdminControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return adminControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 등록.
   *
   * 관리자를 등록합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerCreate(params: AdminControllerCreate$Params, context?: HttpContext): Observable<void> {
    return this.adminControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `adminControllerFindAll()` */
  static readonly AdminControllerFindAllPath = '/api/v1/admin/list';

  /**
   * 전체 관리자 조회.
   *
   * 전체 관리자를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerFindAll$Response(params?: AdminControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AdminDto>>> {
    return adminControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 전체 관리자 조회.
   *
   * 전체 관리자를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerFindAll(params?: AdminControllerFindAll$Params, context?: HttpContext): Observable<Array<AdminDto>> {
    return this.adminControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AdminDto>>): Array<AdminDto> => r.body)
    );
  }

  /** Path part for operation `adminControllerFindById()` */
  static readonly AdminControllerFindByIdPath = '/api/v1/admin/{id}';

  /**
   * 관리자 조회.
   *
   * 입력한 ID와 일치하는 관리자를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerFindById$Response(params: AdminControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    return adminControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 조회.
   *
   * 입력한 ID와 일치하는 관리자를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerFindById(params: AdminControllerFindById$Params, context?: HttpContext): Observable<AdminDto> {
    return this.adminControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminControllerDelete()` */
  static readonly AdminControllerDeletePath = '/api/v1/admin/{id}';

  /**
   * 관리자 삭제.
   *
   * 관리자를 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerDelete$Response(params: AdminControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return adminControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 삭제.
   *
   * 관리자를 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerDelete(params: AdminControllerDelete$Params, context?: HttpContext): Observable<void> {
    return this.adminControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `adminControllerBlockOrUnblock()` */
  static readonly AdminControllerBlockOrUnblockPath = '/api/v1/admin/{id}';

  /**
   * 관리자 차단 | 차단 해제.
   *
   * 관리자를 차단 | 차단 해제 합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerBlockOrUnblock()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerBlockOrUnblock$Response(params: AdminControllerBlockOrUnblock$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    return adminControllerBlockOrUnblock(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 차단 | 차단 해제.
   *
   * 관리자를 차단 | 차단 해제 합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerBlockOrUnblock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerBlockOrUnblock(params: AdminControllerBlockOrUnblock$Params, context?: HttpContext): Observable<AdminDto> {
    return this.adminControllerBlockOrUnblock$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminControllerLogin()` */
  static readonly AdminControllerLoginPath = '/api/v1/admin/login';

  /**
   * 관리자 로그인.
   *
   * 관리자로 로그인 합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerLogin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerLogin$Response(params: AdminControllerLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    return adminControllerLogin(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 로그인.
   *
   * 관리자로 로그인 합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerLogin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerLogin(params: AdminControllerLogin$Params, context?: HttpContext): Observable<AdminDto> {
    return this.adminControllerLogin$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminControllerResetPassword()` */
  static readonly AdminControllerResetPasswordPath = '/api/v1/admin/reset-password/{id}';

  /**
   * 관리자 비밀번호를 변경합니다.
   *
   * 관리자 비밀번호를 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerResetPassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerResetPassword$Response(params: AdminControllerResetPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    return adminControllerResetPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 비밀번호를 변경합니다.
   *
   * 관리자 비밀번호를 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerResetPassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerResetPassword(params: AdminControllerResetPassword$Params, context?: HttpContext): Observable<AdminDto> {
    return this.adminControllerResetPassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

}
